'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _common = require('../../common');

var _commonPopovers = require('../../common-popovers');

var _containers = require('../../../containers');

var _constants = require('../../../constants');

var _utils = require('../../../utils');

var _ShareableDocumentTable = require('./ShareableDocumentTable');

var _ShareableDocumentTable2 = _interopRequireDefault(_ShareableDocumentTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getOrDefault = _utils.FormattingUtils.getOrDefault;
var renderDate = _utils.TableRenderingUtils.renderDate,
    renderFilenameLink = _utils.TableRenderingUtils.renderFilenameLink,
    renderFileType = _utils.TableRenderingUtils.renderFileType;
var PERMISSIONS = _constants.AppConstants.PERMISSIONS,
    SHARE_DOCUMENT_TYPES = _constants.AppConstants.SHARE_DOCUMENT_TYPES;


var GuardedDeleteButton = (0, _containers.createGuardedContainer)({
  disabledComponent: (0, _containers.createDisabledContainer)(_common.DeleteButton),
  enabledComponent: _common.DeleteButton,
  permissionName: PERMISSIONS.DELETE_CASE_DOCUMENTS
});

var CaseDocuments = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(CaseDocuments, _Component);

  function CaseDocuments() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CaseDocuments);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaseDocuments.__proto__ || Object.getPrototypeOf(CaseDocuments)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isUploading', _descriptor, _this), _initDefineProp(_this, 'uploadModalShowing', _descriptor2, _this), _initDefineProp(_this, 'refTable', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CaseDocuments, [{
    key: 'setTableRef',
    value: function setTableRef(ref) {
      this.refTable = ref;
    }
  }, {
    key: 'onClickDelete',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var _props, _case, CaseStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, _case = _props._case, CaseStore = _props.CaseStore;
                _context.next = 3;
                return CaseStore.deleteCaseDocument({ caseId: _case.id, id: id });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onClickDelete(_x) {
        return _ref2.apply(this, arguments);
      }

      return onClickDelete;
    }()
  }, {
    key: 'handleDrop',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(files) {
        var _props2, _case, CaseStore, SessionStore, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, _case = _props2._case, CaseStore = _props2.CaseStore, SessionStore = _props2.SessionStore;


                this.isUploading = true;

                _context2.prev = 2;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 6;
                _iterator = files[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 15;
                  break;
                }

                file = _step.value;
                _context2.next = 12;
                return CaseStore.createCaseDocument({
                  caseId: _case.id,
                  data: {
                    file: file,
                    name: file.name
                  }
                });

              case 12:
                _iteratorNormalCompletion = true;
                _context2.next = 8;
                break;

              case 15:
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 21:
                _context2.prev = 21;
                _context2.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(21);

              case 29:
                SessionStore.trackEvent('BULK_CASE_DOCUMENT_UPLOAD', { file_count: files.length });
                _context2.next = 35;
                break;

              case 32:
                _context2.prev = 32;
                _context2.t1 = _context2['catch'](2);

                // istanbul ignore next
                SessionStore.trackEvent('BULK_CASE_DOCUMENT_UPLOAD_FAILURE', { file_count: files.length });

              case 35:
                _context2.prev = 35;

                this.isUploading = false;
                return _context2.finish(35);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 32, 35, 38], [6, 17, 21, 29], [22,, 24, 28]]);
      }));

      function handleDrop(_x2) {
        return _ref3.apply(this, arguments);
      }

      return handleDrop;
    }()
  }, {
    key: 'onEditDocument',
    value: function onEditDocument(data) {
      var _case = this.props._case,
          _document = (0, _find3.default)(_case.documents, { id: data.id });


      this.currentDocument = _document;
      this.uploadModalShowing.setTrue();
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.currentDocument = null;
      this.uploadModalShowing.setFalse();
    }
  }, {
    key: 'handleDocumentUploadSubmit',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var _props3, _case, CaseStore;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props3 = this.props, _case = _props3._case, CaseStore = _props3.CaseStore;


                if ((0, _get3.default)(data, 'type.id')) {
                  data.type = data.type.id;
                }

                if (!data.id) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 5;
                return CaseStore.updateCaseDocument({ caseId: _case.id, data: data, id: data.id });

              case 5:
                this.currentDocument = null;
                _context3.next = 10;
                break;

              case 8:
                _context3.next = 10;
                return this.handleSingleLienDocumentUpload(data);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleDocumentUploadSubmit(_x3) {
        return _ref4.apply(this, arguments);
      }

      return handleDocumentUploadSubmit;
    }()
  }, {
    key: 'handleSingleLienDocumentUpload',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
        var _props4, _case, CaseStore;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props4 = this.props, _case = _props4._case, CaseStore = _props4.CaseStore;


                this.isUploading = true;
                _context4.next = 4;
                return CaseStore.createCaseDocument({ caseId: _case.id, data: data });

              case 4:
                this.isUploading = false;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleSingleLienDocumentUpload(_x4) {
        return _ref5.apply(this, arguments);
      }

      return handleSingleLienDocumentUpload;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          _case = _props5._case,
          CaseStore = _props5.CaseStore,
          Clients = _props5.Clients;


      return _react2.default.createElement(
        _Well2.default,
        null,
        _react2.default.createElement(
          'form',
          null,
          _react2.default.createElement(_ShareableDocumentTable2.default, {
            _case: _case,
            columns: this.columns,
            documents: (0, _mobx.toJS)(_case.documents),
            documentType: SHARE_DOCUMENT_TYPES.CASE,
            downloadAllUrl: _case.download_all_case_docs_url,
            fetchDocumentsMethod: CaseStore.fetchCaseDocuments,
            hasHeader: true,
            isUploading: this.isUploading,
            onClickAddNew: this.uploadModalShowing.setTrue,
            onDrop: this.handleDrop,
            ref: this.setTableRef,
            shareToRegistryMethod: Clients.caseDocumentsShareToRegistry.updateNoId,
            title: 'Case Documents'
          }),
          this.uploadModalShowing.isTrue && _react2.default.createElement(_common.DocumentUploadModal, {
            _document: this.currentDocument,
            onClose: this.onClose,
            onSubmit: this.handleDocumentUploadSubmit,
            showDocumentTypes: true
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'columns',
    get: function get() {
      var _this2 = this;

      var _props6 = this.props,
          CaseStore = _props6.CaseStore,
          SessionStore = _props6.SessionStore,
          columns = [{
        accessor: 'file',
        Cell: renderFileType,
        className: 'col-file',
        Header: null,
        width: 25
      }, {
        accessor: 'name',
        Cell: renderFilenameLink,
        getViewUrl: SessionStore.getDocumentViewUrl,
        Header: 'Name',
        minWidth: 150,
        sortable: true
      }, {
        accessor: 'type.name',
        Cell: function Cell(row) {
          var typeName = row.value,
              hasEditPermission = SessionStore.userHasPermission(PERMISSIONS.EDIT_CASE_DOCUMENTS);

          if (!typeName && hasEditPermission) {
            return _react2.default.createElement(
              _common.ActionButton,
              { bsStyle: 'link', className: 'btn-add', data: row.original, onClick: _this2.onEditDocument },
              _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
              'Add type'
            );
          }

          return _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'span',
              { className: 'ellipsis' },
              getOrDefault(typeName)
            )
          );
        },
        className: 'col-type col-style-gray',
        Header: 'Type',
        maxWidth: 300,
        minWidth: 125,
        sortable: true
      }, {
        accessor: 'created_at',
        Cell: renderDate,
        className: 'col-date col-style-gray',
        Header: 'Date',
        sortable: true,
        width: 100
      }, {
        accessor: 'id',
        Cell: function Cell(row) {
          var overlayContainer = row.column.overlayContainer,
              hasEditPermission = SessionStore.userHasPermission(PERMISSIONS.EDIT_CASE_DOCUMENTS);

          return _react2.default.createElement(
            'div',
            null,
            hasEditPermission && _react2.default.createElement(
              _common.ActionButton,
              { className: 'btn-edit-type', data: row.original, onClick: _this2.onEditDocument },
              _react2.default.createElement(_common.Icon, { type: 'pencil' })
            ),
            _react2.default.createElement(
              _common.ActionButton,
              { className: 'btn-download', data: row.original.download_url, onClick: CaseStore.onGenerateUrlDocumentDownloadClick },
              _react2.default.createElement(_common.Icon, { type: 'download' })
            ),
            _react2.default.createElement(
              _commonPopovers.ConfirmDeletePopover,
              {
                container: overlayContainer,
                data: row.value,
                name: 'document',
                onDelete: _this2.onClickDelete,
                placement: 'left',
                rootClose: true
              },
              _react2.default.createElement(GuardedDeleteButton, null)
            )
          );
        },
        className: 'col-buttons',
        Header: null,
        overlayContainer: this.refTable,
        width: 100
      }];


      return columns;
    }
  }]);

  return CaseDocuments;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.shape({
    documents: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
    download_all_case_docs_url: _propTypes2.default.string
  }),
  CaseStore: _propTypes2.default.object.isRequired,
  Clients: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isUploading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'uploadModalShowing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool(false);
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'refTable', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'handleDrop', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleDrop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onEditDocument', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onEditDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onClose', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onClose'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = CaseDocuments;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getOrDefault, 'getOrDefault', '/app/src/components/page-case/main-documents/CaseDocuments.js');
  reactHotLoader.register(renderDate, 'renderDate', '/app/src/components/page-case/main-documents/CaseDocuments.js');
  reactHotLoader.register(renderFilenameLink, 'renderFilenameLink', '/app/src/components/page-case/main-documents/CaseDocuments.js');
  reactHotLoader.register(renderFileType, 'renderFileType', '/app/src/components/page-case/main-documents/CaseDocuments.js');
  reactHotLoader.register(PERMISSIONS, 'PERMISSIONS', '/app/src/components/page-case/main-documents/CaseDocuments.js');
  reactHotLoader.register(SHARE_DOCUMENT_TYPES, 'SHARE_DOCUMENT_TYPES', '/app/src/components/page-case/main-documents/CaseDocuments.js');
  reactHotLoader.register(GuardedDeleteButton, 'GuardedDeleteButton', '/app/src/components/page-case/main-documents/CaseDocuments.js');
  reactHotLoader.register(CaseDocuments, 'CaseDocuments', '/app/src/components/page-case/main-documents/CaseDocuments.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-documents/CaseDocuments.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9tYWluLWRvY3VtZW50cy9DYXNlRG9jdW1lbnRzLmpzIl0sIm5hbWVzIjpbImdldE9yRGVmYXVsdCIsIkZvcm1hdHRpbmdVdGlscyIsInJlbmRlckRhdGUiLCJUYWJsZVJlbmRlcmluZ1V0aWxzIiwicmVuZGVyRmlsZW5hbWVMaW5rIiwicmVuZGVyRmlsZVR5cGUiLCJQRVJNSVNTSU9OUyIsIkFwcENvbnN0YW50cyIsIlNIQVJFX0RPQ1VNRU5UX1RZUEVTIiwiR3VhcmRlZERlbGV0ZUJ1dHRvbiIsImRpc2FibGVkQ29tcG9uZW50IiwiRGVsZXRlQnV0dG9uIiwiZW5hYmxlZENvbXBvbmVudCIsInBlcm1pc3Npb25OYW1lIiwiREVMRVRFX0NBU0VfRE9DVU1FTlRTIiwiQ2FzZURvY3VtZW50cyIsImF1dG9CaW5kTWV0aG9kcyIsIm9ic2VydmVyIiwicmVmIiwicmVmVGFibGUiLCJpZCIsInByb3BzIiwiX2Nhc2UiLCJDYXNlU3RvcmUiLCJkZWxldGVDYXNlRG9jdW1lbnQiLCJjYXNlSWQiLCJmaWxlcyIsIlNlc3Npb25TdG9yZSIsImlzVXBsb2FkaW5nIiwiZmlsZSIsImNyZWF0ZUNhc2VEb2N1bWVudCIsImRhdGEiLCJuYW1lIiwidHJhY2tFdmVudCIsImZpbGVfY291bnQiLCJsZW5ndGgiLCJfZG9jdW1lbnQiLCJkb2N1bWVudHMiLCJjdXJyZW50RG9jdW1lbnQiLCJ1cGxvYWRNb2RhbFNob3dpbmciLCJzZXRUcnVlIiwic2V0RmFsc2UiLCJ0eXBlIiwidXBkYXRlQ2FzZURvY3VtZW50IiwiaGFuZGxlU2luZ2xlTGllbkRvY3VtZW50VXBsb2FkIiwiQ2xpZW50cyIsImNvbHVtbnMiLCJDQVNFIiwiZG93bmxvYWRfYWxsX2Nhc2VfZG9jc191cmwiLCJmZXRjaENhc2VEb2N1bWVudHMiLCJoYW5kbGVEcm9wIiwic2V0VGFibGVSZWYiLCJjYXNlRG9jdW1lbnRzU2hhcmVUb1JlZ2lzdHJ5IiwidXBkYXRlTm9JZCIsImlzVHJ1ZSIsIm9uQ2xvc2UiLCJoYW5kbGVEb2N1bWVudFVwbG9hZFN1Ym1pdCIsImFjY2Vzc29yIiwiQ2VsbCIsImNsYXNzTmFtZSIsIkhlYWRlciIsIndpZHRoIiwiZ2V0Vmlld1VybCIsImdldERvY3VtZW50Vmlld1VybCIsIm1pbldpZHRoIiwic29ydGFibGUiLCJyb3ciLCJ0eXBlTmFtZSIsInZhbHVlIiwiaGFzRWRpdFBlcm1pc3Npb24iLCJ1c2VySGFzUGVybWlzc2lvbiIsIkVESVRfQ0FTRV9ET0NVTUVOVFMiLCJvcmlnaW5hbCIsIm9uRWRpdERvY3VtZW50IiwibWF4V2lkdGgiLCJvdmVybGF5Q29udGFpbmVyIiwiY29sdW1uIiwiZG93bmxvYWRfdXJsIiwib25HZW5lcmF0ZVVybERvY3VtZW50RG93bmxvYWRDbGljayIsIm9uQ2xpY2tEZWxldGUiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJzaGFwZSIsImFycmF5T3JPYnNlcnZhYmxlQXJyYXkiLCJpc1JlcXVpcmVkIiwic3RyaW5nIiwib2JqZWN0Iiwib2JzZXJ2YWJsZSIsIlNtYXJ0Qm9vbCIsImFjdGlvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7Ozs7OztBQUtBOztBQU9BOztBQUNBOztBQUNBOztBQUVBOztBQUtBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFHRUEsWSxHQUNFQyxzQixDQURGRCxZO0lBSUFFLFUsR0FHRUMsMEIsQ0FIRkQsVTtJQUNBRSxrQixHQUVFRCwwQixDQUZGQyxrQjtJQUNBQyxjLEdBQ0VGLDBCLENBREZFLGM7SUFJQUMsVyxHQUVFQyx1QixDQUZGRCxXO0lBQ0FFLG9CLEdBQ0VELHVCLENBREZDLG9COzs7QUFHRixJQUFNQyxzQkFBc0Isd0NBQXVCO0FBQ2pEQyxxQkFBbUIseUNBQXdCQyxvQkFBeEIsQ0FEOEI7QUFFakRDLG9CQUFrQkQsb0JBRitCO0FBR2pERSxrQkFBZ0JQLFlBQVlRO0FBSHFCLENBQXZCLENBQTVCOztJQWFNQyxhLFdBUEwsdUJBQ0MsV0FERCxFQUVDLFNBRkQsRUFHQyxjQUhELEMsb0JBS0FDLGdDLGVBQ0FDLG1COzs7Ozs7Ozs7Ozs7Ozs7Ozs7O2dDQW1HY0MsRyxFQUFLO0FBQ2hCLFdBQUtDLFFBQUwsR0FBZ0JELEdBQWhCO0FBQ0Q7Ozs7MkZBRW9CRSxFOzs7Ozs7O3lCQUNVLEtBQUtDLEssRUFBMUJDLEssVUFBQUEsSyxFQUFPQyxTLFVBQUFBLFM7O3VCQUNUQSxVQUFVQyxrQkFBVixDQUE2QixFQUFFQyxRQUFRSCxNQUFNRixFQUFoQixFQUFvQkEsTUFBcEIsRUFBN0IsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs0RkFJVU0sSzs7Ozs7OzswQkFLWixLQUFLTCxLLEVBSFBDLEssV0FBQUEsSyxFQUNBQyxTLFdBQUFBLFMsRUFDQUksWSxXQUFBQSxZOzs7QUFHRixxQkFBS0MsV0FBTCxHQUFtQixJQUFuQjs7Ozs7Ozs0QkFHcUJGLEs7Ozs7Ozs7O0FBQVJHLG9COzt1QkFDSE4sVUFBVU8sa0JBQVYsQ0FBNkI7QUFDakNMLDBCQUFRSCxNQUFNRixFQURtQjtBQUVqQ1csd0JBQU07QUFDSkYsOEJBREk7QUFFSkcsMEJBQU1ILEtBQUtHO0FBRlA7QUFGMkIsaUJBQTdCLEM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQVFSTCw2QkFBYU0sVUFBYixDQUF3QiwyQkFBeEIsRUFBcUQsRUFBRUMsWUFBWVIsTUFBTVMsTUFBcEIsRUFBckQ7Ozs7Ozs7O0FBR0E7QUFDQVIsNkJBQWFNLFVBQWIsQ0FBd0IsbUNBQXhCLEVBQTZELEVBQUVDLFlBQVlSLE1BQU1TLE1BQXBCLEVBQTdEOzs7OztBQUdBLHFCQUFLUCxXQUFMLEdBQW1CLEtBQW5COzs7Ozs7Ozs7Ozs7Ozs7Ozs7O21DQUtZRyxJLEVBQU07QUFDZCxVQUFFVCxLQUFGLEdBQVksS0FBS0QsS0FBakIsQ0FBRUMsS0FBRjtBQUFBLFVBQ0ZjLFNBREUsR0FDVSxvQkFBS2QsTUFBTWUsU0FBWCxFQUFzQixFQUFDakIsSUFBSVcsS0FBS1gsRUFBVixFQUF0QixDQURWOzs7QUFJTixXQUFLa0IsZUFBTCxHQUF1QkYsU0FBdkI7QUFDQSxXQUFLRyxrQkFBTCxDQUF3QkMsT0FBeEI7QUFDRDs7OzhCQUdVO0FBQ1QsV0FBS0YsZUFBTCxHQUF1QixJQUF2QjtBQUNBLFdBQUtDLGtCQUFMLENBQXdCRSxRQUF4QjtBQUNEOzs7OzRGQUVpQ1YsSTs7Ozs7OzswQkFDSCxLQUFLVixLLEVBQTFCQyxLLFdBQUFBLEssRUFBT0MsUyxXQUFBQSxTOzs7QUFFZixvQkFBSSxtQkFBSVEsSUFBSixFQUFVLFNBQVYsQ0FBSixFQUEwQjtBQUN4QkEsdUJBQUtXLElBQUwsR0FBWVgsS0FBS1csSUFBTCxDQUFVdEIsRUFBdEI7QUFDRDs7cUJBRUdXLEtBQUtYLEU7Ozs7Ozt1QkFDREcsVUFBVW9CLGtCQUFWLENBQTZCLEVBQUVsQixRQUFRSCxNQUFNRixFQUFoQixFQUFvQlcsVUFBcEIsRUFBMEJYLElBQUlXLEtBQUtYLEVBQW5DLEVBQTdCLEM7OztBQUNOLHFCQUFLa0IsZUFBTCxHQUF1QixJQUF2Qjs7Ozs7O3VCQUdNLEtBQUtNLDhCQUFMLENBQW9DYixJQUFwQyxDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OzRGQUk0QkEsSTs7Ozs7OzswQkFDUCxLQUFLVixLLEVBQTFCQyxLLFdBQUFBLEssRUFBT0MsUyxXQUFBQSxTOzs7QUFFZixxQkFBS0ssV0FBTCxHQUFtQixJQUFuQjs7dUJBQ01MLFVBQVVPLGtCQUFWLENBQTZCLEVBQUVMLFFBQVFILE1BQU1GLEVBQWhCLEVBQW9CVyxVQUFwQixFQUE3QixDOzs7QUFDTixxQkFBS0gsV0FBTCxHQUFtQixLQUFuQjs7Ozs7Ozs7Ozs7Ozs7Ozs7OzZCQUdRO0FBQUEsb0JBQzhCLEtBQUtQLEtBRG5DO0FBQUEsVUFDQUMsS0FEQSxXQUNBQSxLQURBO0FBQUEsVUFDT0MsU0FEUCxXQUNPQSxTQURQO0FBQUEsVUFDa0JzQixPQURsQixXQUNrQkEsT0FEbEI7OztBQUdSLGFBQ0U7QUFBQyxzQkFBRDtBQUFBO0FBQ0U7QUFBQTtBQUFBO0FBQ0Usd0NBQUMsZ0NBQUQ7QUFDRSxtQkFBT3ZCLEtBRFQ7QUFFRSxxQkFBUyxLQUFLd0IsT0FGaEI7QUFHRSx1QkFBVyxnQkFBS3hCLE1BQU1lLFNBQVgsQ0FIYjtBQUlFLDBCQUFjN0IscUJBQXFCdUMsSUFKckM7QUFLRSw0QkFBZ0J6QixNQUFNMEIsMEJBTHhCO0FBTUUsa0NBQXNCekIsVUFBVTBCLGtCQU5sQztBQU9FLDJCQVBGO0FBUUUseUJBQWEsS0FBS3JCLFdBUnBCO0FBU0UsMkJBQWUsS0FBS1csa0JBQUwsQ0FBd0JDLE9BVHpDO0FBVUUsb0JBQVEsS0FBS1UsVUFWZjtBQVdFLGlCQUFLLEtBQUtDLFdBWFo7QUFZRSxtQ0FBdUJOLFFBQVFPLDRCQUFSLENBQXFDQyxVQVo5RDtBQWFFLG1CQUFNO0FBYlIsWUFERjtBQWdCRyxlQUFLZCxrQkFBTCxDQUF3QmUsTUFBeEIsSUFDQyw4QkFBQywyQkFBRDtBQUNFLHVCQUFXLEtBQUtoQixlQURsQjtBQUVFLHFCQUFTLEtBQUtpQixPQUZoQjtBQUdFLHNCQUFVLEtBQUtDLDBCQUhqQjtBQUlFO0FBSkY7QUFqQko7QUFERixPQURGO0FBNkJEOzs7Ozs7Ozs7O3dCQTVNYztBQUFBOztBQUFBLG9CQUN1QixLQUFLbkMsS0FENUI7QUFBQSxVQUNMRSxTQURLLFdBQ0xBLFNBREs7QUFBQSxVQUNNSSxZQUROLFdBQ01BLFlBRE47QUFBQSxVQUVUbUIsT0FGUyxHQUVDLENBQ1Y7QUFDRVcsa0JBQVUsTUFEWjtBQUVFQyxjQUFNckQsY0FGUjtBQUdFc0QsbUJBQVcsVUFIYjtBQUlFQyxnQkFBUSxJQUpWO0FBS0VDLGVBQU87QUFMVCxPQURVLEVBUVY7QUFDRUosa0JBQVUsTUFEWjtBQUVFQyxjQUFNdEQsa0JBRlI7QUFHRTBELG9CQUFZbkMsYUFBYW9DLGtCQUgzQjtBQUlFSCxnQkFBUSxNQUpWO0FBS0VJLGtCQUFVLEdBTFo7QUFNRUMsa0JBQVU7QUFOWixPQVJVLEVBZ0JWO0FBQ0VSLGtCQUFVLFdBRFo7QUFFRUMsY0FBTSxjQUFDUSxHQUFELEVBQVM7QUFDYixjQUFNQyxXQUFXRCxJQUFJRSxLQUFyQjtBQUFBLGNBQ0lDLG9CQUFvQjFDLGFBQWEyQyxpQkFBYixDQUErQmhFLFlBQVlpRSxtQkFBM0MsQ0FEeEI7O0FBSUEsY0FBSSxDQUFDSixRQUFELElBQWFFLGlCQUFqQixFQUFvQztBQUNsQyxtQkFDRTtBQUFDLGtDQUFEO0FBQUEsZ0JBQWMsU0FBUSxNQUF0QixFQUE2QixXQUFVLFNBQXZDLEVBQWlELE1BQU1ILElBQUlNLFFBQTNELEVBQXFFLFNBQVMsT0FBS0MsY0FBbkY7QUFDRSw0Q0FBQyxZQUFELElBQU0sTUFBSyxlQUFYLEdBREY7QUFBQTtBQUFBLGFBREY7QUFLRDs7QUFFRCxpQkFDRTtBQUFDLDJCQUFEO0FBQUE7QUFDRTtBQUFBO0FBQUEsZ0JBQU0sV0FBVSxVQUFoQjtBQUE0QnpFLDJCQUFhbUUsUUFBYjtBQUE1QjtBQURGLFdBREY7QUFLRCxTQXBCSDtBQXFCRVIsbUJBQVcseUJBckJiO0FBc0JFQyxnQkFBUSxNQXRCVjtBQXVCRWMsa0JBQVUsR0F2Qlo7QUF3QkVWLGtCQUFVLEdBeEJaO0FBeUJFQyxrQkFBVTtBQXpCWixPQWhCVSxFQTJDVjtBQUNFUixrQkFBVSxZQURaO0FBRUVDLGNBQU14RCxVQUZSO0FBR0V5RCxtQkFBVyx5QkFIYjtBQUlFQyxnQkFBUSxNQUpWO0FBS0VLLGtCQUFVLElBTFo7QUFNRUosZUFBTztBQU5ULE9BM0NVLEVBbURWO0FBQ0VKLGtCQUFVLElBRFo7QUFFRUMsY0FBTSxjQUFDUSxHQUFELEVBQVM7QUFDUCxjQUFZUyxnQkFBWixHQUFtQ1QsR0FBbkMsQ0FBRVUsTUFBRixDQUFZRCxnQkFBWjtBQUFBLGNBQ0ZOLGlCQURFLEdBQ2tCMUMsYUFBYTJDLGlCQUFiLENBQStCaEUsWUFBWWlFLG1CQUEzQyxDQURsQjs7QUFFTixpQkFDRTtBQUFBO0FBQUE7QUFDR0YsaUNBQ0M7QUFBQyxrQ0FBRDtBQUFBLGdCQUFjLFdBQVUsZUFBeEIsRUFBd0MsTUFBTUgsSUFBSU0sUUFBbEQsRUFBNEQsU0FBUyxPQUFLQyxjQUExRTtBQUNFLDRDQUFDLFlBQUQsSUFBTSxNQUFLLFFBQVg7QUFERixhQUZKO0FBTUU7QUFBQyxrQ0FBRDtBQUFBLGdCQUFjLFdBQVUsY0FBeEIsRUFBdUMsTUFBTVAsSUFBSU0sUUFBSixDQUFhSyxZQUExRCxFQUF3RSxTQUFTdEQsVUFBVXVELGtDQUEzRjtBQUNFLDRDQUFDLFlBQUQsSUFBTSxNQUFLLFVBQVg7QUFERixhQU5GO0FBU0U7QUFBQyxrREFBRDtBQUFBO0FBQ0UsMkJBQVdILGdCQURiO0FBRUUsc0JBQU1ULElBQUlFLEtBRlo7QUFHRSxzQkFBSyxVQUhQO0FBSUUsMEJBQVUsT0FBS1csYUFKakI7QUFLRSwyQkFBVSxNQUxaO0FBTUU7QUFORjtBQVFFLDRDQUFDLG1CQUFEO0FBUkY7QUFURixXQURGO0FBc0JELFNBM0JIO0FBNEJFcEIsbUJBQVcsYUE1QmI7QUE2QkVDLGdCQUFRLElBN0JWO0FBOEJFZSwwQkFBa0IsS0FBS3hELFFBOUJ6QjtBQStCRTBDLGVBQU87QUEvQlQsT0FuRFUsQ0FGRDs7O0FBeUZiLGFBQU9mLE9BQVA7QUFDRDs7OztFQWhHeUJrQyxnQixXQW9ObkJDLFMsR0FBWTtBQUNqQjNELFNBQU80RCxvQkFBVUMsS0FBVixDQUFnQjtBQUNyQjlDLGVBQVc0QyxxQkFBVUcsc0JBQVYsQ0FBaUNDLFVBRHZCO0FBRXJCckMsZ0NBQTRCa0Msb0JBQVVJO0FBRmpCLEdBQWhCLENBRFU7QUFLakIvRCxhQUFXMkQsb0JBQVVLLE1BQVYsQ0FBaUJGLFVBTFg7QUFNakJ4QyxXQUFTcUMsb0JBQVVLLE1BQVYsQ0FBaUJGLFVBTlQ7QUFPakIxRCxnQkFBY3VELG9CQUFVSyxNQUFWLENBQWlCRjtBQVBkLEMsdUZBbk5sQkcsZ0I7OztXQUF5QixLOzt1RkFDekJBLGdCOzs7V0FBZ0MsSUFBSUMsZ0JBQUosQ0FBYyxLQUFkLEM7OzZFQUNoQ0QsZ0I7OztXQUFzQixJOztnRUF3R3RCRSxZLHlKQStCQUEsWSxzSkFVQUEsWTtlQTJFWTNFLGE7Ozs7Ozs7Ozs7OzBCQTFQYmYsWTswQkFJQUUsVTswQkFDQUUsa0I7MEJBQ0FDLGM7MEJBSUFDLFc7MEJBQ0FFLG9COzBCQUdJQyxtQjswQkFhQU0sYSIsImZpbGUiOiJDYXNlRG9jdW1lbnRzLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50LCBGcmFnbWVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgYXV0b0JpbmRNZXRob2RzIGZyb20gJ2NsYXNzLWF1dG9iaW5kLWRlY29yYXRvcic7XG5pbXBvcnQgeyBhY3Rpb24sIG9ic2VydmFibGUsIHRvSlMgfSBmcm9tICdtb2J4JztcbmltcG9ydCB7IGluamVjdCwgb2JzZXJ2ZXIsIHByb3BUeXBlcyB9IGZyb20gJ21vYngtcmVhY3QnO1xuaW1wb3J0IHsgZ2V0LCBmaW5kIH0gZnJvbSAnbG9kYXNoJztcblxuaW1wb3J0IHsgV2VsbCB9IGZyb20gJ3JlYWN0LWJvb3RzdHJhcCc7XG5cbmltcG9ydCB7XG4gIEFjdGlvbkJ1dHRvbixcbiAgRGVsZXRlQnV0dG9uLFxuICBEb2N1bWVudFVwbG9hZE1vZGFsLFxuICBJY29uLFxufSBmcm9tICcuLi8uLi9jb21tb24nO1xuXG5pbXBvcnQgeyBDb25maXJtRGVsZXRlUG9wb3ZlciB9IGZyb20gJy4uLy4uL2NvbW1vbi1wb3BvdmVycyc7XG5pbXBvcnQgeyBjcmVhdGVHdWFyZGVkQ29udGFpbmVyLCBjcmVhdGVEaXNhYmxlZENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uL2NvbnRhaW5lcnMnO1xuaW1wb3J0IHsgQXBwQ29uc3RhbnRzIH0gZnJvbSAnLi4vLi4vLi4vY29uc3RhbnRzJztcblxuaW1wb3J0IHtcbiAgRm9ybWF0dGluZ1V0aWxzLFxuICBTbWFydEJvb2wsXG4gIFRhYmxlUmVuZGVyaW5nVXRpbHMsXG59IGZyb20gJy4uLy4uLy4uL3V0aWxzJztcbmltcG9ydCBTaGFyZWFibGVEb2N1bWVudFRhYmxlIGZyb20gJy4vU2hhcmVhYmxlRG9jdW1lbnRUYWJsZSc7XG5cbmNvbnN0IHtcbiAgZ2V0T3JEZWZhdWx0LFxufSA9IEZvcm1hdHRpbmdVdGlscztcblxuY29uc3Qge1xuICByZW5kZXJEYXRlLFxuICByZW5kZXJGaWxlbmFtZUxpbmssXG4gIHJlbmRlckZpbGVUeXBlLFxufSA9IFRhYmxlUmVuZGVyaW5nVXRpbHM7XG5cbmNvbnN0IHtcbiAgUEVSTUlTU0lPTlMsXG4gIFNIQVJFX0RPQ1VNRU5UX1RZUEVTLFxufSA9IEFwcENvbnN0YW50cztcblxuY29uc3QgR3VhcmRlZERlbGV0ZUJ1dHRvbiA9IGNyZWF0ZUd1YXJkZWRDb250YWluZXIoe1xuICBkaXNhYmxlZENvbXBvbmVudDogY3JlYXRlRGlzYWJsZWRDb250YWluZXIoRGVsZXRlQnV0dG9uKSxcbiAgZW5hYmxlZENvbXBvbmVudDogRGVsZXRlQnV0dG9uLFxuICBwZXJtaXNzaW9uTmFtZTogUEVSTUlTU0lPTlMuREVMRVRFX0NBU0VfRE9DVU1FTlRTLFxufSk7XG5cbkBpbmplY3QoXG4gICdDYXNlU3RvcmUnLFxuICAnQ2xpZW50cycsXG4gICdTZXNzaW9uU3RvcmUnLFxuKVxuQGF1dG9CaW5kTWV0aG9kc1xuQG9ic2VydmVyXG5jbGFzcyBDYXNlRG9jdW1lbnRzIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgQG9ic2VydmFibGUgaXNVcGxvYWRpbmcgPSBmYWxzZTtcbiAgQG9ic2VydmFibGUgdXBsb2FkTW9kYWxTaG93aW5nID0gbmV3IFNtYXJ0Qm9vbChmYWxzZSk7XG4gIEBvYnNlcnZhYmxlIHJlZlRhYmxlID0gbnVsbDtcbiAgY3VycmVudERvY3VtZW50O1xuXG4gIGdldCBjb2x1bW5zICgpIHtcbiAgICBjb25zdCB7IENhc2VTdG9yZSwgU2Vzc2lvblN0b3JlIH0gPSB0aGlzLnByb3BzXG4gICAgICAsIGNvbHVtbnMgPSBbXG4gICAgICAgIHtcbiAgICAgICAgICBhY2Nlc3NvcjogJ2ZpbGUnLFxuICAgICAgICAgIENlbGw6IHJlbmRlckZpbGVUeXBlLFxuICAgICAgICAgIGNsYXNzTmFtZTogJ2NvbC1maWxlJyxcbiAgICAgICAgICBIZWFkZXI6IG51bGwsXG4gICAgICAgICAgd2lkdGg6IDI1LFxuICAgICAgICB9LFxuICAgICAgICB7XG4gICAgICAgICAgYWNjZXNzb3I6ICduYW1lJyxcbiAgICAgICAgICBDZWxsOiByZW5kZXJGaWxlbmFtZUxpbmssXG4gICAgICAgICAgZ2V0Vmlld1VybDogU2Vzc2lvblN0b3JlLmdldERvY3VtZW50Vmlld1VybCxcbiAgICAgICAgICBIZWFkZXI6ICdOYW1lJyxcbiAgICAgICAgICBtaW5XaWR0aDogMTUwLFxuICAgICAgICAgIHNvcnRhYmxlOiB0cnVlLFxuICAgICAgICB9LFxuICAgICAgICB7XG4gICAgICAgICAgYWNjZXNzb3I6ICd0eXBlLm5hbWUnLFxuICAgICAgICAgIENlbGw6IChyb3cpID0+IHtcbiAgICAgICAgICAgIGNvbnN0IHR5cGVOYW1lID0gcm93LnZhbHVlXG4gICAgICAgICAgICAgICwgaGFzRWRpdFBlcm1pc3Npb24gPSBTZXNzaW9uU3RvcmUudXNlckhhc1Blcm1pc3Npb24oUEVSTUlTU0lPTlMuRURJVF9DQVNFX0RPQ1VNRU5UUylcbiAgICAgICAgICAgIDtcblxuICAgICAgICAgICAgaWYgKCF0eXBlTmFtZSAmJiBoYXNFZGl0UGVybWlzc2lvbikge1xuICAgICAgICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgICAgIDxBY3Rpb25CdXR0b24gYnNTdHlsZT0nbGluaycgY2xhc3NOYW1lPSdidG4tYWRkJyBkYXRhPXtyb3cub3JpZ2luYWx9IG9uQ2xpY2s9e3RoaXMub25FZGl0RG9jdW1lbnR9PlxuICAgICAgICAgICAgICAgICAgPEljb24gdHlwZT0ncGx1cy1zcXVhcmUtbycgLz5BZGQgdHlwZVxuICAgICAgICAgICAgICAgIDwvQWN0aW9uQnV0dG9uPlxuICAgICAgICAgICAgICApO1xuICAgICAgICAgICAgfVxuXG4gICAgICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgICA8RnJhZ21lbnQ+XG4gICAgICAgICAgICAgICAgPHNwYW4gY2xhc3NOYW1lPSdlbGxpcHNpcyc+e2dldE9yRGVmYXVsdCh0eXBlTmFtZSl9PC9zcGFuPlxuICAgICAgICAgICAgICA8L0ZyYWdtZW50PlxuICAgICAgICAgICAgKTtcbiAgICAgICAgICB9LFxuICAgICAgICAgIGNsYXNzTmFtZTogJ2NvbC10eXBlIGNvbC1zdHlsZS1ncmF5JyxcbiAgICAgICAgICBIZWFkZXI6ICdUeXBlJyxcbiAgICAgICAgICBtYXhXaWR0aDogMzAwLFxuICAgICAgICAgIG1pbldpZHRoOiAxMjUsXG4gICAgICAgICAgc29ydGFibGU6IHRydWUsXG4gICAgICAgIH0sXG4gICAgICAgIHtcbiAgICAgICAgICBhY2Nlc3NvcjogJ2NyZWF0ZWRfYXQnLFxuICAgICAgICAgIENlbGw6IHJlbmRlckRhdGUsXG4gICAgICAgICAgY2xhc3NOYW1lOiAnY29sLWRhdGUgY29sLXN0eWxlLWdyYXknLFxuICAgICAgICAgIEhlYWRlcjogJ0RhdGUnLFxuICAgICAgICAgIHNvcnRhYmxlOiB0cnVlLFxuICAgICAgICAgIHdpZHRoOiAxMDAsXG4gICAgICAgIH0sXG4gICAgICAgIHtcbiAgICAgICAgICBhY2Nlc3NvcjogJ2lkJyxcbiAgICAgICAgICBDZWxsOiAocm93KSA9PiB7XG4gICAgICAgICAgICBjb25zdCB7IGNvbHVtbjogeyBvdmVybGF5Q29udGFpbmVyIH0gfSA9IHJvd1xuICAgICAgICAgICAgICAsIGhhc0VkaXRQZXJtaXNzaW9uID0gU2Vzc2lvblN0b3JlLnVzZXJIYXNQZXJtaXNzaW9uKFBFUk1JU1NJT05TLkVESVRfQ0FTRV9ET0NVTUVOVFMpO1xuICAgICAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICAgICAgPGRpdj5cbiAgICAgICAgICAgICAgICB7aGFzRWRpdFBlcm1pc3Npb24gJiZcbiAgICAgICAgICAgICAgICAgIDxBY3Rpb25CdXR0b24gY2xhc3NOYW1lPSdidG4tZWRpdC10eXBlJyBkYXRhPXtyb3cub3JpZ2luYWx9IG9uQ2xpY2s9e3RoaXMub25FZGl0RG9jdW1lbnR9PlxuICAgICAgICAgICAgICAgICAgICA8SWNvbiB0eXBlPSdwZW5jaWwnIC8+XG4gICAgICAgICAgICAgICAgICA8L0FjdGlvbkJ1dHRvbj5cbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgPEFjdGlvbkJ1dHRvbiBjbGFzc05hbWU9J2J0bi1kb3dubG9hZCcgZGF0YT17cm93Lm9yaWdpbmFsLmRvd25sb2FkX3VybH0gb25DbGljaz17Q2FzZVN0b3JlLm9uR2VuZXJhdGVVcmxEb2N1bWVudERvd25sb2FkQ2xpY2t9PlxuICAgICAgICAgICAgICAgICAgPEljb24gdHlwZT0nZG93bmxvYWQnIC8+XG4gICAgICAgICAgICAgICAgPC9BY3Rpb25CdXR0b24+XG4gICAgICAgICAgICAgICAgPENvbmZpcm1EZWxldGVQb3BvdmVyXG4gICAgICAgICAgICAgICAgICBjb250YWluZXI9e292ZXJsYXlDb250YWluZXJ9XG4gICAgICAgICAgICAgICAgICBkYXRhPXtyb3cudmFsdWV9XG4gICAgICAgICAgICAgICAgICBuYW1lPSdkb2N1bWVudCdcbiAgICAgICAgICAgICAgICAgIG9uRGVsZXRlPXt0aGlzLm9uQ2xpY2tEZWxldGV9XG4gICAgICAgICAgICAgICAgICBwbGFjZW1lbnQ9J2xlZnQnXG4gICAgICAgICAgICAgICAgICByb290Q2xvc2VcbiAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICA8R3VhcmRlZERlbGV0ZUJ1dHRvbiAvPlxuICAgICAgICAgICAgICAgIDwvQ29uZmlybURlbGV0ZVBvcG92ZXI+XG4gICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgKTtcbiAgICAgICAgICB9LFxuICAgICAgICAgIGNsYXNzTmFtZTogJ2NvbC1idXR0b25zJyxcbiAgICAgICAgICBIZWFkZXI6IG51bGwsXG4gICAgICAgICAgb3ZlcmxheUNvbnRhaW5lcjogdGhpcy5yZWZUYWJsZSxcbiAgICAgICAgICB3aWR0aDogMTAwLFxuICAgICAgICB9LFxuICAgICAgXVxuICAgICAgO1xuXG4gICAgcmV0dXJuIGNvbHVtbnM7XG4gIH1cblxuICBzZXRUYWJsZVJlZiAocmVmKSB7XG4gICAgdGhpcy5yZWZUYWJsZSA9IHJlZjtcbiAgfVxuXG4gIGFzeW5jIG9uQ2xpY2tEZWxldGUgKGlkKSB7XG4gICAgY29uc3QgeyBfY2FzZSwgQ2FzZVN0b3JlIH0gPSB0aGlzLnByb3BzO1xuICAgIGF3YWl0IENhc2VTdG9yZS5kZWxldGVDYXNlRG9jdW1lbnQoeyBjYXNlSWQ6IF9jYXNlLmlkLCBpZCB9KTtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgaGFuZGxlRHJvcCAoZmlsZXMpIHtcbiAgICBjb25zdCB7XG4gICAgICBfY2FzZSxcbiAgICAgIENhc2VTdG9yZSxcbiAgICAgIFNlc3Npb25TdG9yZSxcbiAgICB9ID0gdGhpcy5wcm9wcztcblxuICAgIHRoaXMuaXNVcGxvYWRpbmcgPSB0cnVlO1xuXG4gICAgdHJ5IHtcbiAgICAgIGZvciAoY29uc3QgZmlsZSBvZiBmaWxlcykge1xuICAgICAgICBhd2FpdCBDYXNlU3RvcmUuY3JlYXRlQ2FzZURvY3VtZW50KHtcbiAgICAgICAgICBjYXNlSWQ6IF9jYXNlLmlkLFxuICAgICAgICAgIGRhdGE6IHtcbiAgICAgICAgICAgIGZpbGUsXG4gICAgICAgICAgICBuYW1lOiBmaWxlLm5hbWUsXG4gICAgICAgICAgfSxcbiAgICAgICAgfSk7XG4gICAgICB9XG4gICAgICBTZXNzaW9uU3RvcmUudHJhY2tFdmVudCgnQlVMS19DQVNFX0RPQ1VNRU5UX1VQTE9BRCcsIHsgZmlsZV9jb3VudDogZmlsZXMubGVuZ3RoIH0pO1xuICAgIH1cbiAgICBjYXRjaCAoZSkge1xuICAgICAgLy8gaXN0YW5idWwgaWdub3JlIG5leHRcbiAgICAgIFNlc3Npb25TdG9yZS50cmFja0V2ZW50KCdCVUxLX0NBU0VfRE9DVU1FTlRfVVBMT0FEX0ZBSUxVUkUnLCB7IGZpbGVfY291bnQ6IGZpbGVzLmxlbmd0aCB9KTtcbiAgICB9XG4gICAgZmluYWxseSB7XG4gICAgICB0aGlzLmlzVXBsb2FkaW5nID0gZmFsc2U7XG4gICAgfVxuICB9XG5cbiAgQGFjdGlvblxuICBvbkVkaXREb2N1bWVudCAoZGF0YSkge1xuICAgIGNvbnN0IHsgX2Nhc2UgfSA9IHRoaXMucHJvcHNcbiAgICAgICwgX2RvY3VtZW50ID0gZmluZChfY2FzZS5kb2N1bWVudHMsIHtpZDogZGF0YS5pZH0pXG4gICAgICA7XG5cbiAgICB0aGlzLmN1cnJlbnREb2N1bWVudCA9IF9kb2N1bWVudDtcbiAgICB0aGlzLnVwbG9hZE1vZGFsU2hvd2luZy5zZXRUcnVlKCk7XG4gIH1cblxuICBAYWN0aW9uXG4gIG9uQ2xvc2UgKCkge1xuICAgIHRoaXMuY3VycmVudERvY3VtZW50ID0gbnVsbDtcbiAgICB0aGlzLnVwbG9hZE1vZGFsU2hvd2luZy5zZXRGYWxzZSgpO1xuICB9XG5cbiAgYXN5bmMgaGFuZGxlRG9jdW1lbnRVcGxvYWRTdWJtaXQgKGRhdGEpIHtcbiAgICBjb25zdCB7IF9jYXNlLCBDYXNlU3RvcmUgfSA9IHRoaXMucHJvcHM7XG5cbiAgICBpZiAoZ2V0KGRhdGEsICd0eXBlLmlkJykpIHtcbiAgICAgIGRhdGEudHlwZSA9IGRhdGEudHlwZS5pZDtcbiAgICB9XG5cbiAgICBpZiAoZGF0YS5pZCkge1xuICAgICAgYXdhaXQgQ2FzZVN0b3JlLnVwZGF0ZUNhc2VEb2N1bWVudCh7IGNhc2VJZDogX2Nhc2UuaWQsIGRhdGEsIGlkOiBkYXRhLmlkIH0pO1xuICAgICAgdGhpcy5jdXJyZW50RG9jdW1lbnQgPSBudWxsO1xuICAgIH1cbiAgICBlbHNlIHtcbiAgICAgIGF3YWl0IHRoaXMuaGFuZGxlU2luZ2xlTGllbkRvY3VtZW50VXBsb2FkKGRhdGEpO1xuICAgIH1cbiAgfVxuXG4gIGFzeW5jIGhhbmRsZVNpbmdsZUxpZW5Eb2N1bWVudFVwbG9hZCAoZGF0YSkge1xuICAgIGNvbnN0IHsgX2Nhc2UsIENhc2VTdG9yZSB9ID0gdGhpcy5wcm9wcztcblxuICAgIHRoaXMuaXNVcGxvYWRpbmcgPSB0cnVlO1xuICAgIGF3YWl0IENhc2VTdG9yZS5jcmVhdGVDYXNlRG9jdW1lbnQoeyBjYXNlSWQ6IF9jYXNlLmlkLCBkYXRhIH0pO1xuICAgIHRoaXMuaXNVcGxvYWRpbmcgPSBmYWxzZTtcbiAgfVxuXG4gIHJlbmRlciAoKSB7XG4gICAgY29uc3QgeyBfY2FzZSwgQ2FzZVN0b3JlLCBDbGllbnRzIH0gPSB0aGlzLnByb3BzO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxXZWxsPlxuICAgICAgICA8Zm9ybT5cbiAgICAgICAgICA8U2hhcmVhYmxlRG9jdW1lbnRUYWJsZVxuICAgICAgICAgICAgX2Nhc2U9e19jYXNlfVxuICAgICAgICAgICAgY29sdW1ucz17dGhpcy5jb2x1bW5zfVxuICAgICAgICAgICAgZG9jdW1lbnRzPXt0b0pTKF9jYXNlLmRvY3VtZW50cyl9XG4gICAgICAgICAgICBkb2N1bWVudFR5cGU9e1NIQVJFX0RPQ1VNRU5UX1RZUEVTLkNBU0V9XG4gICAgICAgICAgICBkb3dubG9hZEFsbFVybD17X2Nhc2UuZG93bmxvYWRfYWxsX2Nhc2VfZG9jc191cmx9XG4gICAgICAgICAgICBmZXRjaERvY3VtZW50c01ldGhvZD17Q2FzZVN0b3JlLmZldGNoQ2FzZURvY3VtZW50c31cbiAgICAgICAgICAgIGhhc0hlYWRlclxuICAgICAgICAgICAgaXNVcGxvYWRpbmc9e3RoaXMuaXNVcGxvYWRpbmd9XG4gICAgICAgICAgICBvbkNsaWNrQWRkTmV3PXt0aGlzLnVwbG9hZE1vZGFsU2hvd2luZy5zZXRUcnVlfVxuICAgICAgICAgICAgb25Ecm9wPXt0aGlzLmhhbmRsZURyb3B9XG4gICAgICAgICAgICByZWY9e3RoaXMuc2V0VGFibGVSZWZ9XG4gICAgICAgICAgICBzaGFyZVRvUmVnaXN0cnlNZXRob2Q9e0NsaWVudHMuY2FzZURvY3VtZW50c1NoYXJlVG9SZWdpc3RyeS51cGRhdGVOb0lkfVxuICAgICAgICAgICAgdGl0bGU9J0Nhc2UgRG9jdW1lbnRzJ1xuICAgICAgICAgIC8+XG4gICAgICAgICAge3RoaXMudXBsb2FkTW9kYWxTaG93aW5nLmlzVHJ1ZSAmJlxuICAgICAgICAgICAgPERvY3VtZW50VXBsb2FkTW9kYWxcbiAgICAgICAgICAgICAgX2RvY3VtZW50PXt0aGlzLmN1cnJlbnREb2N1bWVudH1cbiAgICAgICAgICAgICAgb25DbG9zZT17dGhpcy5vbkNsb3NlfVxuICAgICAgICAgICAgICBvblN1Ym1pdD17dGhpcy5oYW5kbGVEb2N1bWVudFVwbG9hZFN1Ym1pdH1cbiAgICAgICAgICAgICAgc2hvd0RvY3VtZW50VHlwZXNcbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgfVxuICAgICAgICA8L2Zvcm0+XG4gICAgICA8L1dlbGw+XG4gICAgKTtcbiAgfVxuXG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgX2Nhc2U6IFByb3BUeXBlcy5zaGFwZSh7XG4gICAgICBkb2N1bWVudHM6IHByb3BUeXBlcy5hcnJheU9yT2JzZXJ2YWJsZUFycmF5LmlzUmVxdWlyZWQsXG4gICAgICBkb3dubG9hZF9hbGxfY2FzZV9kb2NzX3VybDogUHJvcFR5cGVzLnN0cmluZyxcbiAgICB9KSxcbiAgICBDYXNlU3RvcmU6IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgICBDbGllbnRzOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gICAgU2Vzc2lvblN0b3JlOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IENhc2VEb2N1bWVudHM7XG4iXX0=